
import { Component, Vue } from 'vue-property-decorator'
import isMobile from '@/widget/utils/isMobile'

@Component
export default class PoweredBy extends Vue {
  isMobile = isMobile()

  private get termsAndConditions(): string {
    return process.env.VUE_APP_TERMS_AND_CONDITIONS ?? ''
  }

  private get poweredBy(): string {
    return process.env.VUE_APP_POWERED_BY ?? ''
  }
}
